import { Component, OnInit, Input } from "@angular/core";
import { Message, SpinnerService } from "shared-components";
import { GestionService } from "../../../services/gestion.service";

@Component({
    selector: 'app-proteccion-denominacion',
    templateUrl: './proteccion-denominacion.component.html',
})

export class ProteccionDenominacionComponent implements OnInit {
    @Input() denominacionId;

    public protecciones;
    public newProteccion = false;

    public showError: boolean;
    public mensajes = new Array<Message>();

    constructor(
        private readonly _spinnerService: SpinnerService,
        private readonly _gestionService: GestionService
    ) {}

    ngOnInit(): void {
        this.getProtecciones();
    }

    private getProtecciones() {
        this._spinnerService.showSpinner();

        const filters = {
            denominacionId: this.denominacionId
        }
        this._gestionService.getProtecciones(filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            // Comprobamos si ya tiene una protección
            this.protecciones = resp.lista?.length > 0 && resp.lista[0]?.titular && resp.lista[0]?.inicioVigencia ? resp.lista : null;
        }, (error) => {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        });
    }

    public showNewProteccion() {
        this.newProteccion = true;
    }

    public hideNewProteccion(refresh: boolean) {
        this.newProteccion = false;

        if (refresh) {
            this.getProtecciones();
        }
    }

    /**
     * Recibido desde el componente hijo
     */
    public pushMessage(message: string) {
        this.showError = true;
        if (message.includes('.error.')) {
            this.mensajes.push({ class: 'error', message: message });
        } else {
            this.mensajes.push({ class: 'success', message: message });
        }
    }
}